import { calculateDateRange } from '../../utils/dates';
import ClockoutController from '../../core/clockout.controller';
import { removeAuthCookie } from '../../utils/cookies';

class DashboardController extends ClockoutController {
    async initialize() {
        try {
            if (this.user?.access === false) {
                removeAuthCookie();
                this.constructor._notifyAuthChange();
                this.navigateLogin();
                return;
            }
            // Check if user has valid data (not just an empty object)
            if (!this.user || !this.user.access || this.user.access.length === 0) {
                this.navigateLogin();
                return;
            }

            const ytdReport = this.data?.user ? await this.data.fetchYTDReport(this.data?.user?.access[0]) : {};
            const user = this.data.user;
            console.log('user', user);
            const segmentPolicy = user?.fi?.segment_policy;
            const hasSegmentPolicy = segmentPolicy && Object.keys(segmentPolicy).length > 0;
            this.setState({ user, ytdReport, showConfigurationReminder: !hasSegmentPolicy });
            await this.fetchData();
        } catch (error) {
            console.log('Error in initialize', error);
        }
    }

    manageReportData(report) {
        const { signedUpUsers, activeUsersCount, inactiveUsersCount, directDepositSwitches, totalUsersWithAdvances } = report;

        if (!signedUpUsers || signedUpUsers === 0) {
            return { ...report, activeUserPercentage: 0, inactiveUserPercentage: 0, directDepositSwitchPercentage: 0, totalUsersWithAdvancesPercentage: 0 };
        }

        const calculatePercentage = (value) => ((value / signedUpUsers) * 100).toFixed(2);

        return {
            ...report,
            activeUserPercentage: calculatePercentage(activeUsersCount),
            inactiveUserPercentage: calculatePercentage(inactiveUsersCount),
            directDepositSwitchPercentage: calculatePercentage(directDepositSwitches),
            totalUsersWithAdvancesPercentage: calculatePercentage(totalUsersWithAdvances)
        };
    }

    async fetchData() {
        this.setState({ loading: true });
        try {
            const { timeFrame, dateRange, selectedGrouping } = this.state;
            const { start, end } = calculateDateRange(timeFrame, dateRange);
            const report = this.data?.user ? await this.data.fetchReport(this.data?.user?.access[0], start, end, selectedGrouping) : {};
            const managedReport = report ? this.manageReportData(report) : {};
            this.setState({ report: managedReport, loading: false });
        } catch (error) {
            console.error('Error fetching data:', error);
            this.setState({ loading: false });
        }
    }

    getGroupingConfig(timeFrame, diffDays = null) {
        const configs = {
            '7d': { availableGroupings: ['daily'], selectedGrouping: 'daily' },
            '30d': { availableGroupings: ['weekly', 'daily'], selectedGrouping: 'weekly' },
            all: { availableGroupings: ['monthly'], selectedGrouping: 'monthly' }
        };

        if (timeFrame === 'custom' && diffDays !== null) {
            if (diffDays <= 7) {
                return { availableGroupings: ['daily'], selectedGrouping: 'daily' };
            } else if (diffDays <= 31) {
                return { availableGroupings: ['weekly', 'daily'], selectedGrouping: 'weekly' };
            } else {
                return { availableGroupings: ['monthly', 'weekly'], selectedGrouping: 'monthly' };
            }
        }

        return configs[timeFrame] || { availableGroupings: ['weekly', 'daily'], selectedGrouping: 'weekly' };
    }

    async handleTimeFrameChange(timeFrame) {
        const { availableGroupings, selectedGrouping } = this.getGroupingConfig(timeFrame);

        this.setState(
            {
                timeFrame,
                availableGroupings,
                selectedGrouping
            },
            async () => {
                if (timeFrame !== 'custom') await this.fetchData();
            }
        );
    }

    async handleDateRangeChange(dateRange) {
        if (!dateRange || dateRange.length !== 2) return;

        const [start, end] = dateRange;
        const diffDays = end.diff(start, 'days');
        const { availableGroupings, selectedGrouping } = this.getGroupingConfig('custom', diffDays);

        this.setState(
            {
                dateRange,
                availableGroupings,
                selectedGrouping
            },
            async () => {
                await this.fetchData();
            }
        );
    }

    async handleGroupingChange(selectedGrouping) {
        this.setState({ selectedGrouping }, async () => {
            await this.fetchData();
        });
    }

    handleConfigurationReminderDismiss() {
        this.setState({ showConfigurationReminder: false });
    }
}

export default DashboardController;
